import { EngineIcon, SealPercentIcon } from '@phosphor-icons/react';

import { formatDiscountValue, formatFlexibleDiscount, formatTierRange } from '../format';
import type { DiscountDetail } from '../types';

import { DiscountBanner } from './discount-banner';
import styles from './discount-tier-table.module.scss';

export function DiscountTierTable({ discount }: { discount: DiscountDetail }) {
  if (discount.quantityRule.type !== 'quantity_based') return null;
  const tiers = discount.quantityRule.tiers ?? [];

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Quantity Rules &amp; Tiered Pricing</h2>
      <ul className={styles.tiers}>
        {tiers.map((tier) => (
          <li key={`${tier.minQty}-${tier.maxQty ?? 'max'}`} className={styles.tier}>
            <span className={styles.range}>
              <EngineIcon size={14} className={styles.rangeIcon} aria-hidden />
              <span className={styles.rangeNum}>{formatTierRange(tier)}</span>
              <span className={styles.unit}>units</span>
            </span>
            <span className={styles.value}>
              <span className={styles.amount}>
                {formatDiscountValue(tier.value, discount.discountFormat)}
              </span>
              <span className={styles.unit}>/unit</span>
            </span>
          </li>
        ))}
      </ul>
      <DiscountBanner
        tone="lime"
        icon={<SealPercentIcon size={14} weight="fill" />}
        title="Flexible Discount"
        description={formatFlexibleDiscount(discount.maximumDiscountLimit, discount.discountFormat)}
      />
    </section>
  );
}
